import React from "react";

/**
 * This view component will be rendered when visiting /pages/greet
 * when your application has been setup with inertiajs.
 */
export default function Book() {
    return <Container></Container>;
}
